import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table table-bordered border-0 mb-0 table-edit"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PROGRAM"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MAXIMUM LOAN AMOUNT $")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "FHA", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "CONVENTIONAL", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "VA", -1)
const _hoisted_6 = {
  key: 1,
  class: "table table-bordered border-0 mb-0 table-edit mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)

import { toRefs } from "vue";
import VueNumberFormat from 'vue-number-format'


export default /*#__PURE__*/_defineComponent({
  __name: 'MaximumLoanAmount',
  props: {
    data: {
        type: Object,
        defaul: null,
    },
},
  setup(__props) {

const props = __props;


const { data } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(data) !== null)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              _createElementVNode("td", null, [
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyPrice",
                  value: _unref(data).fha,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).fha) = $event)),
                  options: {
                                precision: 0,
                                prefix: '$ ',
                                thousand: ',',
                                acceptNegative: false,
                                isInteger: true,
                                decimal: '.',
                            }
                }, null, 8, ["value", "options"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_4,
              _createElementVNode("td", null, [
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyPrice",
                  value: _unref(data).conventional,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).conventional) = $event)),
                  options: {
                                precision: 0,
                                prefix: '$ ',
                                thousand: ',',
                                acceptNegative: false,
                                isInteger: true,
                                decimal: '.',
                            }
                }, null, 8, ["value", "options"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("td", null, [
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyPrice",
                  value: _unref(data).va,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).va) = $event)),
                  options: {
                                precision: 0,
                                prefix: '$ ',
                                thousand: ',',
                                acceptNegative: false,
                                isInteger: true,
                                decimal: '.',
                            }
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(data) !== null)
      ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "5",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(data).comments) = $event))
                }, null, 512), [
                  [_vModelText, _unref(data).comments]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})